import { v4 as uuidv4 } from 'uuid';

import { STATUS_LOADED } from 'constants/MediaConstants';

/**
 * @param {import("modules/guidelines/types").AbstractMedia} media
 * @param {Partial<import("ui/base/MediasUploader/types").MediaUploaderItem>} [defaultValue]
 * @returns {Partial<import("ui/base/MediasUploader/types").MediaUploaderItem>}
 */
export const muMediaFormatter = (media, defaultValue = {}) => ({
  file: {},
  uuid: uuidv4(),
  status: STATUS_LOADED,
  ...defaultValue,
  data: media,
});

export const TEMPLATE_EXTENSIONS = {
  CSV: 'csv',
  XLSX: 'xlsx',
};
